<template>
  <div class="container-fluid">
    <br>
    <router-link to="/usuarios" class="btn-default btn"><i class="fa fa-times"></i> {{$t('words.cancel') }}
    </router-link>
    <button type="button" :disabled="loading || sameUser" @click="saveData" class="btn btn-success float-right">
      <i class="fa fa-check"></i>
      {{$t('words.save')}}
      <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
    </button>
    <br>
    <br>
      <div class="card card-outline card-outline-tabs" :class="appLayout.card">
        <div class="card-header p-0 border-bottom-0">
          <div class="nav-tabs-custom" role="tabpanel">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="nav-item">
                <a class="nav-link active"> <i class="fa fa-lock"></i> {{ $t('words.permissions')}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Tab panes -->
        <div class="card-body">
          <div class="tab-content">
            <div class="tab-pane active" id="tabFormulario">
              <img class="img-circle" :src="user.avatar" style="width:50px;height:50px" alt="User Image">
              <strong>
                {{user.nome}}
              </strong>
              <p>{{ $t('message.user_permission')}}</p>
              <hr>
              <div class="row">
              <div class="col-md-12">
                <div class="info-box" style="min-height:100px">
                  <span class="info-box-icon bg-red" style="min-height:100px;line-height:100px"><i
                      class="fa fa-lock"></i></span>
                  <div class="row container-fluid">
                    <div v-for="(item, i) in permissions" :key="i" class="col-md-3 col-sm-3">
                      <div class="form-group">
                        <p-check class="p-switch p-fill" v-model="user.permissoes" :value="item.id"
                          :color="appLayout.check">
                          <strong>{{item.display_name}}</strong></p-check>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
</template>
<script>
  export default {
    data() {
      return {
        user: {
          permissoes: []
        },
        selectAllGeral: false,
        selectAllFinanceiro: false,
        selectAllEstoque: false,
        selectAllFiscal: false,
        selectAllPdv: false,
        loading: false,
      };
    },
    mounted() {
      if (this.$store.state.cargo.permissions.length === 0) {
        this.$store.dispatch('getCargoPermissions').then(response => {
          this.$store.commit('SET_CARGO_PERMISSIONS', response);
        });
      }
    },
    beforeMount() {
      this.getUser();
      this.allow = this.allow.bind(this);
    },
    watch: {
      $route(data) {
        if (data.name === 'userPermissions') {
          this.getUser();
        }
      }
    },
    computed: {
      permissions() {
        return this.$store.state.cargo.permissions;
      },
      sameUser() {
        return this.auth_user.id === this.user.id && this.auth_auth_user.ambiente !== 'A';
      }
    },
    methods: {
      setPage(n) {
        this.currentPage = n;
      },
      canEdit(taskName) {
        return (!this.allow(taskName) && this.auth_auth_user.ambiente !== 'A') || (this.sameUser && this.auth_auth_user
          .ambiente !== 'A')
      },
      getUser() {
        this.$store
          .dispatch('getUserPermissions', this.$route.params.id)
          .then(response => {
            this.user = response;
            this.verifyChecks();
          });
      },
      saveData() {
        let obj = {};
        obj.id = this.user.id;
        obj.permissions = this.user.permissoes;
        this.loading = true;
        this.$store
          .dispatch('changeUserPermissions', obj)
          .then(response => {
            this.loading = false;
            toastr({
              icon: response.status,
              title: response.message
            });
          });
      },
      allowChange(task) {
        if (this.auth_user.id === this.user.id) return true;
        return !this.$store.state.user.permissoes.some(e => e.name === task);
      },
      handdleSelectedGeral() {
        this.removeSelected(this.permissions.geral);
        if (this.selectAllGeral) {
          this.permissions.geral.map(item => {
            if (this.allow(item.name)) {
              this.user.permissoes.push(item.id);
            }
          });
        }
      },
      handdleSelectedFinanceiro() {
        this.removeSelected(this.permissions.financeiro);
        if (this.selectAllFinanceiro) {
          this.permissions.financeiro.map(item => {
            if (this.allow(item.name)) {
              this.user.permissoes.push(item.id);
            }
          });
        }
      },
      handdleSelectedEstoque() {
        this.removeSelected(this.permissions.estoque);
        if (this.selectAllEstoque) {
          this.permissions.estoque.map(item => {
            if (this.allow(item.name)) {
              this.user.permissoes.push(item.id);
            }
          });
        }
      },
      handdleSelectedFiscal() {
        this.removeSelected(this.permissions.fiscal);
        if (this.selectAllFiscal) {
          this.permissions.fiscal.map(item => {
            if (this.allow(item.name)) {
              this.user.permissoes.push(item.id);
            }
          });
        }
      },
      handdleSelectedPdv() {
        this.removeSelected(this.permissions.pdv);
        if (this.selectAllPdv) {
          this.permissions.pdv.map(item => {
            this.user.permissoes.push(item.id);
          });
        }
      },
      removeSelected(array) {
        this.user.permissoes = this.user.permissoes.filter(item =>
          array.findIndex(x => x.id === item && this.allow(x.name)) === -1);
      },
      verifyChecks() {
        this.selectAllGeral = true;
        this.selectAllFinanceiro = true;
        this.selectAllEstoque = true;
        this.selectAllFiscal = true;
        this.selectAllPdv = true;

        this.permissions.geral.map(item => {
          if (this.user.permissoes.findIndex(x => x === item.id) === -1) {
            this.selectAllGeral = false;
          }
        });

        this.permissions.financeiro.map(item => {
          if (this.user.permissoes.findIndex(x => x === item.id) === -1) {
            this.selectAllFinanceiro = false;
          }
        });

        this.permissions.estoque.map(item => {
          if (this.user.permissoes.findIndex(x => x === item.id) === -1) {
            this.selectAllEstoque = false;
          }
        });

        this.permissions.fiscal.map(item => {
          if (this.user.permissoes.findIndex(x => x === item.id) === -1) {
            this.selectAllFiscal = false;
          }
        });

        this.permissions.pdv.map(item => {
          if (this.user.permissoes.findIndex(x => x === item.id) === -1) {
            this.selectAllPdv = false;
          }
        });
      }
    }
  };
</script>